<template>
    <v-card>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
            <v-card-title primary-title class="grey lighten-4">
                <v-avatar size="40">
                    <v-icon color="primary">person</v-icon>
                </v-avatar>
                <v-spacer></v-spacer>
                <div v-if="requirements.sat != null">
                    <H2>Datos del Agremiado</H2>
                    <strong>CPC:</strong> {{ requirements.sat.cpc }} <br>
                    <strong>Nombre:</strong> {{ requirements.sat.name_user }}<br>
                    <strong>Correo:</strong> {{ requirements.sat.email_user }}<br>
                    <strong>Móvil:</strong> {{ requirements.sat.movil_user }}
                </div>
                <v-spacer></v-spacer>
                <div>
                  <h2>Datos de la Actuación</h2>
                    <strong>TIPO:</strong> {{ requirements.sat.categoria ? requirements.sat.categoria : '' }}<br>
                    <strong>RIF:</strong> {{ requirements.sat.number_id }}<br>
                    <strong>CLIENTE:</strong> {{ requirements.sat.client }}<br>
                    <strong>MONTO:</strong> {{ Number(requirements.sat.amount).toLocaleString('es-VE') }}
                </div>
                <br>

                <v-spacer></v-spacer>
            </v-card-title>

                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto elevation-0">
                                    <v-container>
                                        <v-layout row wrap class="justify-center">
                                            <v-flex sm3 xs12 md3 lg3 pa-1 v-for="doc in requirements.documents_requirement" :key="doc.id">
                                                <v-flex xs12 pa-1 v-for="document1 in doc" :key="document1.id">
                                                    <h2 v-if="!document1.required" class="caption">{{ document1.description }}</h2>
                                                    <v-btn color="blue-grey" class="white--text" v-if="document1.required && document1.unionize_check" @click="deleteItem(document1)">
                                                        Eliminar {{ document1.description }}
                                                        <v-icon right dark>delete</v-icon>
                                                    </v-btn>
                                                    <DropZone v-on:responseSuccess="responseSuccess($event)" v-if="document1.required && !document1.unionize_check" :document="document1" :ruap_id="requirements.sat.id"/>
                                                </v-flex>
                                            </v-flex>
                                            <br />
                                        </v-layout>
                                        <div class="layout justify-center row wrap"><strong>Cada archivo deberá estar en formato PDF y mantener  orientación vertical en todo el documento.</strong></div>

                                        <br />
                                        <br />
                                        <div class="layout justify-center row wrap" v-if="requirements.devolution_ruaps.length != 0">
                                            <h5>Observaciones para devoluciones:</h5>
                                            <v-flex class="layout justify-center row wrap" xs12 v-for="dev in requirements.devolution_ruaps" :key="dev.id">
                                                <p>*{{dev.observation}}</p>
                                            </v-flex>
                                        </div>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>

            <v-card-actions>
                <v-btn color="primary darken-1" @click="$emit('closeValidate')">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" @click="submitForm">Validar</v-btn>
            </v-card-actions>
        </v-form>
  </v-card>
</template>
<script>
import Form from 'vform'
import axios from 'axios'
import DropZone from '~/components/DropZone.vue'

export default {

    props: {
        requirements: {
            type: Object,
            default: []
        }
    },

    components: {
        DropZone
    },

    watch: {
      requirements(v) {
        let bad = 0
        for (const key in v.documents_requirement) {
          if (v.documents_requirement.hasOwnProperty(key)) {
            for (let index = 0; index < v.documents_requirement[key].length; index++) {
                if(v.documents_requirement[key][index].required){
                    if(v.documents_requirement[key][index].unionize_check == false || v.documents_requirement[key][index].unionize_check == null){
                        bad++
                    }
                }else{
                    this.form.id_padre = v.documents_requirement[key][index].id
                }
            }
          }
        }
        this.validDocuments = bad == 0 ? true : false
      }
    },

    mounted() {
      this.init_module = true
    },

    data: () => ({
        percentCompleted: 0,
        row: [],
        content_id: null,
        init_module: false,
        valid: false,
        validDocuments: false,
        form: new Form({
            id_padre: null,
            devolution_activate: false,
            ruap_id: ''
        }),
        active: [],
        avatar: null,
        open: [],
        users: []
    }),

    methods: {

        async submitForm() {
            if (this.validDocuments) {
                this.$emit('loadingResponse', true)
                this.form.ruap_id = this.requirements.sat.id
                await axios.post(`/api/cliente/ap-revision-completed`, this.form).then(resp => {
                    //emit socket
                    // this.$socket.emit('updateRuapListSocket', resp.data)
                            this.$store.dispatch('responseMessage', {
                                type: 'success',
                                text: 'Validacion exitosa!..'
                            })
                            this.close()
                        }).catch(error => {
                            this.$emit('loadingResponse', false)
                            console.log(error.response,'revision error')
                        })
            }else {
                await this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'Faltan Archivos por cargar'
                })
            }
        },

        onFocus(id) {
            this.content_id = id
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "application/pdf") {
                this.form.documents.splice(this.content_id, files[0].name)
                this.form.files[this.content_id] = files[0]
                this.form.documents[this.content_id] = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PDF'
                })
            }
        },

        async responseSuccess(response){
            let bad = 0
            let esto = this
            response.document_requiremets.forEach(function(element) {
                if(element.document_data.required){
                    if(element.unionize_check == false || element.unionize_check == null){
                        bad++
                    }
                }else{
                    esto.form.id_padre = element.id
                }
            });

            this.validDocuments = bad == 0 ? true : false
        },

        async deleteItem(item){
            let agreement = confirm(`Esta Seguro de eliminar el ${item.description}?`)
            if(agreement){
                this.$emit('loadingResponse', true)
                await axios.post(`/api/cliente/ap-document-deleted`, item).then(resp => {
                            this.$store.dispatch('searchDocumentRuapRequirement', resp.data)
                            this.$store.dispatch('responseMessage', {
                                type: 'info',
                                text: `Se elimino ${item.description}`
                            })
                        }).catch(error => {
                            console.log(error.response,'revision error')
                        }).finally(() => this.$emit('loadingResponse', false));
            }
        },

        async close() {
            let esto = this
            setTimeout(function(){
                esto.$emit('loadingResponse', false)
                esto.$emit('validarActuacion', false)
                esto.$router.push('mis-actuaciones')
            }, 2000);
        },

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/FormValidarActuacion.vue